import { Button } from '@winnin/winnin_ui.components.button'
import { CheckboxWithActions } from '@winnin/winnin_ui.components.checkbox-with-actions'
import { InputWithLabel } from '@winnin/winnin_ui.components.input-with-label'
import { Title } from '@winnin/winnin_ui.components.title'

import { RCTooltip } from 'components/RCTooltip'
import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import type { IGlobalTopicFilter } from './global-topic-filter.types'

import './global-topic-filter.styles.scss'

export const GlobalTopicFilterView = ({
  territoriesList,
  handleToggleTerritory,
  handleToggleExcludeTerritory,
  handleClear,
  search,
  handleSearch,
}: IGlobalTopicFilter) => {
  const t = useTranslate()
  return (
    <div className="GlobalTopicFilter">
      <div className="GlobalTopicFilter-header">
        <Title tag="h5">{t(TOLGEE_GLOBALS.territories)}</Title>
        <Button className="GlobalTopicFilter-clear-button" onClick={handleClear} variation="faded" appearance="link">
          {t(TOLGEE_GLOBALS.clear)}
        </Button>
      </div>
      <div className="GlobalTopicFilter-search">
        <InputWithLabel placeholder={t(TOLGEE_GLOBALS.searchTerm)} value={search} onChange={handleSearch} />
      </div>
      <div className="GlobalTopicFilter-list">
        {territoriesList.map(territory => {
          return (
            <RCTooltip key={territory.territoryId} direction="bottom" tooltipMessage={territory.name}>
              <CheckboxWithActions
                checkboxClick={() => handleToggleTerritory(territory.value, territory.name)}
                label={territory.name}
                labelClick={() => handleToggleExcludeTerritory(territory.value, territory.name)}
                hoverText={territory.isExcluded ? t(TOLGEE_GLOBALS.clear) : t(TOLGEE_GLOBALS.exclude)}
                className="GlobalTopicFilter-item"
                isActive={territory.isInIncluded}
                isDisabled={territory.isExcluded}
              />
            </RCTooltip>
          )
        })}
      </div>
    </div>
  )
}
